<template>
  <div class="interview-guidance">
    <h1>面试辅导</h1>
    <div class="service-category">留学服务</div>

    <section class="guidance-section">
      <div class="intro">
        <p>在加拿大的大学本科的申请过程中，一些商科和工程专业会要求同学们录制视频进行面试，而学校会通过这些视频来考察学生的个人兴趣爱好，辩证思考的能力，在面临压力时的表现，和英语口语的流畅度。</p>
        <p>不同于一般的真人面试，录制视频面试是由提前录制好的视频播放面试问题，根据申请的项目不同会要求学生在30-60秒的时间内对于提出的问题作出60-120秒的回答，没有真人面试官作出表情反馈和互动，并且只有一次机会不能重复录制，对大部分学生的临场发挥能力和抗压能力都是一种挑战。</p>
        <p>加拿大的大学非常注重一个学生的个性化、创造力以及思维的辩证能力，而视频面试则是给了学生一个机会去展示自己敏捷的思维和有趣的个性。如果可以在面试中展示出自己这一面，便会给面试官留下一个深刻的印象。</p>
        <p>在回答问题时需要用到不同的技巧和方法，这就要提前做好充分的准备，避免视频录制面试时过于紧张。</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'InterviewGuidanceView'
}
</script>

<style scoped lang="less">
.interview-guidance {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .service-category {
    color: #666;
    font-size: 18px;
    margin-bottom: 30px;
  }

  .guidance-section {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .intro {
      margin-bottom: 40px;

      p {
        margin-bottom: 20px;
        line-height: 1.8;
        color: #444;
      }
    }

    .interview-types,
    .interview-focus,
    .preparation-tips {
      h2 {
        font-size: 24px;
        color: #e63946;
        margin: 30px 0 15px;
        padding-bottom: 10px;
        border-bottom: 2px solid #eee;
      }

      p {
        margin-bottom: 15px;
        line-height: 1.8;
        color: #555;
        text-align: justify;
      }
    }

    .preparation-tips {
      ul {
        list-style: disc;
        padding-left: 20px;
        margin-top: 15px;

        li {
          color: #555;
          margin-bottom: 10px;
          line-height: 1.6;
        }
      }
    }
  }
}
</style>